export const CAMPAIGNID = process.env.REACT_APP_CAMPAIGNID;
export const SAAS_CAMPAIGNID = process.env.REACT_APP_SAAS_CAMPAIGNID;
export const TENANTID = process.env.REACT_APP_TENANTID;
export const BUSINESS_ACCOUNT_ID = process.env.REACT_APP_BUSINESS_ACCOUNT_ID;

export const START_DATE = process.env.REACT_APP_START_DATE_CAMPAIGN;
export const START_DATE_TIME = process.env.REACT_APP_START_DATE_TIME_CAMPAIGN;

export const END_DATE = process.env.REACT_APP_END_DATE_CAMPAIGN;
export const END_DATE_TIME = process.env.REACT_APP_END_DATE_TIME_CAMPAIGN;

export const LINK_VIDEO = process.env.REACT_APP_LINK_VIDEO;

export const STATIC_PATH = process.env.REACT_APP_STATIC_PATH;
export const TICKET_GIFTID = process.env.REACT_APP_TICKET_GIFTID;
export const GOLD_GIFTID = process.env.REACT_APP_GOLD_GIFTID;
export const BOX_GIFT_GIFTID = process.env.REACT_APP_BOX_GIFT_GIFTID;
export const CARD10K_GIFTID = process.env.REACT_APP_CARD10K_GIFTID;
export const GOOD_LUCK_GIFTID = process.env.REACT_APP_GOOD_LUCK_GIFTID;

export const IS_LOAD_ASSETS_FROM_URL =
  process.env.REACT_APP_IS_LOAD_ASSETS_FROM_URL;
export const HOTLINE = "<strong>1900 636 736</strong>";
export const TELCO = [
  {
    label: "Viettel",
    value: "Viettel",
  },
  {
    label: "Vinaphone",
    value: "Vinaphone",
  },
  {
    label: "Mobiphone",
    value: "Mobiphone",
  },

  {
    label: "Vietnamobile",
    value: "Vietnamobile",
  },
];
